exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".phone-number-input-container{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;position:relative}.phone-number-input-container .country-code{position:absolute;left:.75rem;color:inherit}.phone-number-input-container .phone-number-input{padding-left:calc(.75rem + 20px)}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/common/form/PhoneNumberInput.scss
// module id = 714
// module chunks = 1